import { ConnectButton } from "@rainbow-me/rainbowkit";
import { ReactComponent as GitcoinLogo } from "../../assets/gitcoinlogo-black.svg";
import { ReactComponent as GrantsExplorerLogo } from "../../assets/topbar-logos-black.svg";
import { ReactComponent as GrantsExplorerLogoMobile } from "../../assets/explorer-logo-mobile.svg";
import NavbarCart from "./NavbarCart";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { useAccount } from "wagmi";
import { useCartStorage } from "../../store";
import { Link } from "react-router-dom";
import { getAlloVersion } from "common/src/config";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
// Note: we use this during a GG round, disabling until then.
// import ExploreRoundsDropdown, {
//   ExploreRoundsDropdownProps,
// } from "./ExploreRoundsDropdown";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function Navbar(props) {
  var _props$showWalletInte;
  /** This part keeps the store in sync between tabs */
  const store = useCartStorage();
  const updateStore = () => {
    useCartStorage.persist.rehydrate();
  };
  useEffect(() => {
    document.addEventListener("visibilitychange", updateStore);
    window.addEventListener("focus", updateStore);
    return () => {
      document.removeEventListener("visibilitychange", updateStore);
      window.removeEventListener("focus", updateStore);
    };
  }, []);
  /** end of part that keeps the store in sync between tabs */

  const showWalletInteraction = (_props$showWalletInte = props.showWalletInteraction) !== null && _props$showWalletInte !== void 0 ? _props$showWalletInte : true;
  const {
    address: walletAddress
  } = useAccount();
  const alloVersion = getAlloVersion();

  // Note: we use this during a GG round, disabling until then.
  // todo: update this list with GG21 featured rounds.
  // const rounds: ExploreRoundsDropdownProps[] = [
  // example:
  //   {
  //     chainId: 42161,
  //     roundId: "26",
  //     name: "WEB3 Infrastructure",
  //     link: "/round/42161/26",
  //   },
  // ];

  return /*#__PURE__*/_jsxs("nav", {
    className: `blurred fixed w-full z-20 shadow-[0_4px_24px_0px_rgba(0,0,0,0.08)] ${props.customBackground}`,
    children: [/*#__PURE__*/_jsx("div", {
      className: "mx-auto px-4 sm:px-6 lg:px-20 max-w-screen-2xl",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex justify-between h-16",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex",
          children: /*#__PURE__*/_jsx(Link, {
            to: "/",
            className: "flex-shrink-0 flex items-center",
            "data-testid": "home-link",
            children: /*#__PURE__*/_jsxs("div", {
              className: "flex gap-1 lg:gap-3 items-center",
              children: [/*#__PURE__*/_jsx(GitcoinLogo, {
                className: ""
              }), /*#__PURE__*/_jsx("div", {
                className: "border-grey-400 border-2 h-4 border-r ml-[2px]"
              }), /*#__PURE__*/_jsx(GrantsExplorerLogo, {
                className: "hidden lg:block"
              }), /*#__PURE__*/_jsx(GrantsExplorerLogoMobile, {
                className: "lg:hidden"
              })]
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-row items-center gap-6 font-mono font-medium",
          children: [showWalletInteraction && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("div", {
              "data-testid": "connect-wallet-button",
              id: "connect-wallet-button",
              children: /*#__PURE__*/_jsx(ConnectButton, {
                showBalance: false,
                accountStatus: {
                  smallScreen: "avatar",
                  largeScreen: "full"
                },
                chainStatus: {
                  smallScreen: "icon"
                }
              })
            })
          }), walletAddress && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Link, {
              to: `/contributors/${walletAddress}`,
              className: "flex-shrink-0 flex items-center ph-no-capture",
              "data-testid": "contributions-link",
              children: /*#__PURE__*/_jsx(UserCircleIcon, {
                className: "h-8 w-8 ph-no-capture"
              })
            })
          }), /*#__PURE__*/_jsx(NavbarCart, {
            cart: store.projects
          })]
        })]
      })
    }), props.showAlloVersionBanner && /*#__PURE__*/_jsx("div", {
      className: "bg-white/40 backdrop-blur-sm p-4 text-center w-full font-medium flex flex-col items-center justify-center text-black",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ExclamationCircleIcon, {
          className: "h-5 w-5 inline-block mr-2"
        }), alloVersion === "allo-v2" ? /*#__PURE__*/_jsxs(_Fragment, {
          children: ["Rounds launched before the 25th of March appear on Allo v1. Check out those rounds", " ", /*#__PURE__*/_jsx("a", {
            className: "underline",
            target: "_blank",
            href: "https://explorer-v1.gitcoin.co",
            children: "here"
          }), "!"]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: ["Rounds launched after the 24th of March appear on Allo v2. Check out those rounds", " ", /*#__PURE__*/_jsx("a", {
            className: "underline",
            target: "_blank",
            href: "https://explorer.gitcoin.co",
            children: "here"
          }), "!"]
        })]
      })
    })]
  });
}